export default {
    ADD_NOTIFICATION: "ADD_NOTIFICATION"
}


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js